import { payment } from '@/core/data/forms'
import { defineStore } from 'pinia'
import { reactive, ref } from "vue"

import { useSessionStore } from '@/store/session';

export const usePosStore = defineStore('pos', () => {

    const sessionStore = useSessionStore();
    const activeClass = ref('order')
    const showDivisionModal = ref(false)
    const loadingProgress = ref(false)
    const selectedCustomer = ref('');

    const formPos = reactive({
        ID: null,
        divisi: null as any | null,
        divisi_team: null as any | null,
        transaction_date: null as Date | null,
        customer: null as any | null,
        order_details: [] as any[],
        interaction: null as any | null,
        locations: '' as string,
        shipping: null as any | null,
        courier: null as any | null,
        courier_other_name: '',
        bank: null as any | null,
        bank_account: null as any | null,
        payment: 'TRANSFER',
        payment_image: null as string | null,
        shipping_cost: 0 as number,
        qty_total: 0 as number,
        sub_total: 0 as number,
        fee_percent: 3 as number,
        fee_amount: 0 as number,
        grand_total: 0 as number,
        order_status: null as string | null,
        sales_email: null as string | null,
        sales_name: null as string | null,
    })
    function showDivision(){
        showDivisionModal.value = true
    }

    function connvertForm() {
        let formPosTemp = { ...formPos }
        if (formPosTemp.order_details.length > 0) {
            formPosTemp.order_details = formPosTemp.order_details.map((item: any) => {
                console.log(item);
                const total = (item.price * item.quantity) - item.discount;
                const itemTemp = {
                    name: item?.name,
                    description: item.description,
                    image: item.image,
                    unit: item.unit,
                    quantity: item.quantity,
                    discount: item.discount,
                    price: item.price,
                    total: total
                }
                return itemTemp;
            })
            formPosTemp.qty_total = formPosTemp.order_details.reduce((sum, item) => sum + item.quantity, 0);
        }

        // delete formPosTemp?.divisi?.divisiTeams;
        // delete formPosTemp?.divisi_team?.divisi;
        // delete formPosTemp?.bank?.accounts;
        // delete formPosTemp?.customer?.divisi?.divisi_team;
        // delete formPosTemp?.customer?.divisi_team?.divisi;
        // delete formPosTemp?.shipping?.couriers;

        // formPosTemp.divisi_id = formPosTemp.divisi.ID;
        // formPosTemp.divisi = formPosTemp.divisi ? JSON.stringify(formPosTemp.divisi) : null;
        // formPosTemp.divisi_team_id = formPosTemp.divisi_team.ID;
        // formPosTemp.divisi_team = formPosTemp.divisi_team ? JSON.stringify(formPosTemp.divisi_team) : null;
        if (formPosTemp.payment != 'TRANSFER') {
            formPosTemp.bank = null
            formPosTemp.bank_account = null
        }
        // else{
        //     formPosTemp.bank = formPosTemp.bank? JSON.stringify(formPosTemp.bank) : null
        //     formPosTemp.bank_account = formPosTemp.bank_account? JSON.stringify(formPosTemp.bank_account) : null
        // }
        // formPosTemp.customer = formPosTemp.customer? JSON.stringify(formPosTemp.customer) : null
        // formPosTemp.shipping = formPosTemp.shipping? JSON.stringify(formPosTemp.shipping) : null
        // formPosTemp.courier = formPosTemp.courier? JSON.stringify(formPosTemp.courier) : null

        formPosTemp.order_status = "PENDING";
        formPosTemp.sales_email = sessionStore.user?.email;
        formPosTemp.sales_name = sessionStore.user?.nickname;
        return formPosTemp;
    }

    function checkDivisionModal() {
        if (formPos.divisi == null || formPos.divisi_team == null) {
            showDivisionModal.value = true
        } else {
            showDivisionModal.value = false
        }
    }

    // import * as sales from "@/services/sales"
    function proceedTo(to: string) {
        activeClass.value = to
    }
    function changeFeeAmount(amount: number) {
        formPos.fee_amount = amount
        recalculateTotals()
    }
    function changeFeePercent(percent: number) {
        formPos.fee_percent = percent
        recalculateTotals()
    }

    function changeShippingCost(amount: number) {
        formPos.shipping_cost = amount
        recalculateTotals()
    }

    function recalculateTotals() {
        // Calculate subtotal by summing price * quantity - discount for each item
        formPos.sub_total = formPos.order_details.reduce((sum, item) => {
            const itemTotal = ((item.price * (item.quantity || 0))) - (item.discount || 0);
            return sum + itemTotal;
        }, 0);
        formPos.fee_amount = ((formPos.sub_total +  formPos.shipping_cost) * formPos.fee_percent) / 100
        formPos.fee_amount = Number(formPos.fee_amount.toFixed(2))
        // Calculate grand total by adding fees and shipping to subtotal
        formPos.grand_total = Number(formPos.sub_total) + Number(formPos.fee_amount) + Number(formPos.shipping_cost);
    }

    function addToCart(product: any) {
        // Cek apakah produk sudah ada di keranjang, jika ya update quantity dan discount
        const existing = formPos.order_details.find(item => item.ID === product.ID)
        if (existing) {
            existing.quantity += product.quantity
            existing.discount += product.discount
        } else {
            formPos.order_details.push({ ...product, quantity: product.quantity, discount: product.discount })
        }
        recalculateTotals()
    }

    function removeFromCart(index: number) {
        formPos.order_details.splice(index, 1)
        recalculateTotals()
    }

    function resetFormPos(to: string) {
        // Reset form to default values
        activeClass.value = to
        formPos.ID = null
        formPos.divisi = formPos.divisi
        formPos.divisi_team = formPos.divisi_team
        formPos.transaction_date = new Date()
        formPos.customer = null
        formPos.order_details = []
        formPos.locations = ''
        formPos.shipping = null
        formPos.interaction = null
        formPos.bank = null
        formPos.bank_account = null
        formPos.payment = 'TRANSFER'
        formPos.payment_image = null
        formPos.shipping_cost = 0
        formPos.qty_total = 0
        formPos.sub_total = 0
        formPos.fee_percent = 3
        formPos.fee_amount = 0
        formPos.grand_total = 0
        formPos.order_status = null
        formPos.sales_email = null
        formPos.sales_name = null
    }

    return {
        loadingProgress,
        showDivision,
        showDivisionModal,
        activeClass,
        selectedCustomer,
        formPos,
        proceedTo,
        checkDivisionModal,
        addToCart,
        removeFromCart,
        recalculateTotals,
        resetFormPos,
        changeFeeAmount,
        changeShippingCost,
        connvertForm,
        changeFeePercent
    }
})
